import { Component, OnInit, Input, HostBinding, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FileExtension } from '../file-upload/file-upload.component';
import MetaFileLink from 'src/app/models/metaFileLink.model';

@Component({
  selector: 'terra-files-selector',
  templateUrl: './files-selector.component.html',
  styleUrls: ['./files-selector.component.scss']
})
export class FilesSelectorComponent implements OnInit {

  fileList: FileList;

  @Input()
  supportedExtensions: FileExtension[];

  @Output()
  filesSelected = new EventEmitter<FileList>();

  @HostBinding('class.read-only-mode') readOnlyMode = false;

  @ViewChild('fileInput') fileInput: ElementRef;


  constructor() { }

  ngOnInit() {
  }

  showFileBrowser() {
    this.fileInput.nativeElement.click();
  }

  getSupportedFileTypes() {
    if (!this.supportedExtensions || this.supportedExtensions.length === 0) {
      return '.pdf, .png, .jpg, .jpeg';
    } else {
      const typesString = this.supportedExtensions.join(', ');
      return typesString;
    }
  }

  fileChange(event) {
    if (this.readOnlyMode) {
      return;
    }
    this.fileList = event.target.files;

    if (this.fileList.length > 0) {
      this.filesSelected.emit(this.fileList);
    }
  }

}
